import Address from "./Address"
class EventDetails {
    constructor(
      id,
      title,
      description,
      startDate,
      startTime,
      ticketUrl,
      averagePrice,
      venue,
      address,
      imageUrls,
      isLiked,
      isPromoted,
      isSponsored,
      moreDates
    ) {
      this.id = id;
      this.title = title;
      this.description = description;
      this.startDate = startDate;
      this.startTime = startTime;
      this.ticketUrl = ticketUrl;
      this.averagePrice = averagePrice;
      this.venue = venue;
      this.address = address;
      this.imageUrls = imageUrls;
      this.isLiked = isLiked;
      this.isPromoted = isPromoted;
      this.isSponsored = isSponsored;
      this.moreDates = moreDates;
    }

    static fromJson(json) {
        console.dir(json);
        return new EventDetails(
          json.id,
          json.title,
          json.description,
          json.startDate,
          json.startTime,
          json.ticketUrl,
          json.averagePrice,
          json.venue,
          Address.fromJson(json.address),
          json.imageUrls,
          json.isLiked,
          json.isPromoted,
          json.isSponsored,
          json.moreDates
        );
      }
  }

  export default EventDetails;